import {viewModel} from "@/class/view-model";
import {story} from "@/class/story";

export class stories extends viewModel {
    
    objectType = "stories";
    name = "All stories";
    
    data = [
        {name: "stories", type: Array, default:[]}
    ]
    
    constructor() {
        super();
        this.init();
        this._isList = true;
    }
    
    setDataReq(data){
        
        data.forEach((_story) => {
            let st = new story().setDataReq(_story)
            st.parentObjectType = "stories"
            
            this.stories.push(st)
        })
        
    }
    
    getThumbnail() {
        return store.state.defaults.defaultBaseImage
    }
    
    deleteStory(story){
        story.delete();
        this.stories = this.stories.filter(s => s !== story)
    }
    
    getRoute(){
        return "/stories"
    }
}